import { useContext } from "react";
import { useSelector } from "react-redux";
import PermissionsContext from "./PermissionsContext";

export const usePermissions = () => {
  const permissions = useContext(PermissionsContext);
  const user = useSelector((state) => state.user.user);

  const isAllowed = (code, mode) => {
    if (mode !== "view" && user?.email === "guest@example.com") {
      return false;
    }
    const permission = permissions?.find((item) => item["code"] === code);

    if (permission && permission[mode] === true) {
      return true;
    }

    return false;
  };

  return {
    isAllowed,
  };
};
